// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import HeartFilledSvg from "@ant-design/icons-svg/es/asn/HeartFilled";
import AntdIcon from '../components/AntdIcon';

var HeartFilled = function HeartFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: HeartFilledSvg
  }));
};

HeartFilled.displayName = 'HeartFilled';
export default React.forwardRef(HeartFilled);